import { unlockSetsForRp } from './unlockSetsByRp';
import {
  relationshipLeveledUp,
  relationshipTierIndex,
  relationshipTierLabel
} from './relationshipLevels';

/**
 * Обновить RP персонажа и при необходимости добавить в `sets` альбомы с requiredRelationshipPoints ≤ новый RP.
 * @returns {{ characters: Array, sets: string[], prevRp: number, nextRp: number, newlyUnlockedIds: string[] }}
 */
export function applyRpDeltaToCharactersAndSets(characters, sets, characterId, delta, setsCatalog) {
  const cid = String(characterId);
  const d = Number(delta) || 0;
  const chars = Array.isArray(characters) ? characters.map((c) => ({ ...c })) : [];
  const ix = chars.findIndex((c) => String(c.characterId) === cid);
  const prevRp = ix >= 0 ? Number(chars[ix].relationship) || 0 : 0;
  const nextRp = Math.max(0, prevRp + d);
  const row =
    ix >= 0
      ? { ...chars[ix], relationship: nextRp }
      : { characterId: cid, relationship: nextRp, sessionNumber: 1 };
  if (ix >= 0) chars[ix] = row;
  else chars.push(row);

  const { mergedSetIds, newlyUnlockedIds } = unlockSetsForRp(
    cid,
    nextRp,
    setsCatalog || [],
    sets || []
  );

  return { characters: chars, sets: mergedSetIds, prevRp, nextRp, newlyUnlockedIds };
}

/**
 * Деталь для `game-flow-relationship-up`: тост, модалка тира, модалка альбома (без смены тира).
 * `rewardAlbum` только если есть вновь разблокированные сеты по RP.
 */
export function buildRelationshipRewardDispatchDetail(
  prevRp,
  nextRp,
  gameSettings,
  newlyUnlockedIds,
  setsCatalog
) {
  const tierUp = relationshipLeveledUp(prevRp, nextRp, gameSettings);
  const fromLabel = relationshipTierLabel(relationshipTierIndex(prevRp, gameSettings));
  const toLabel = relationshipTierLabel(relationshipTierIndex(nextRp, gameSettings));

  let rewardAlbum = null;
  if (newlyUnlockedIds?.length > 0 && Array.isArray(setsCatalog)) {
    const sid = newlyUnlockedIds[0];
    const setDoc = setsCatalog.find((s) => String(s._id) === String(sid));
    if (setDoc) {
      rewardAlbum = {
        setId: String(sid),
        title: (setDoc.rewardTitle || setDoc.name || 'Album').trim() || 'Album',
        photoCount: Array.isArray(setDoc.photos) ? setDoc.photos.length : 0,
        coverImageUrl: typeof setDoc.coverImage === 'string' ? setDoc.coverImage.trim() : ''
      };
    }
  }

  return {
    tierUp,
    fromLabel,
    toLabel,
    tierLabel: toLabel,
    delta: nextRp - prevRp,
    rewardAlbum
  };
}
